import api from './api'

const kanabanBoarDataProvider = {
  getKanbanData(params = {}) {
    return api.query('crmtt/api/Board/Board', {
      params,
    })
  },
  updateBoard(params = {}) {
    return api.put('crmtt/api/Board/UpdateBoardIssue', params)
  },
  adminBoard(params = {}) {
    return api.query('crmtt/api/Board/GetBoradAdmin', {
      params,
    })
  },
  updateSuperADmin(params = {}) {
    return api.put('/crmtt/api/Board/UpdateBoard', params)
  }
}

// const kanabanBoarDataProvider = {
//   getKanbanData(params = {}) {
//     return api.query('crmtt/api/Board/BoardColumn', {
//       params,
//     })
//   },
// }

export default kanabanBoarDataProvider
